import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router';
import { ChannelType } from '@type/channelType';
import Box from '@client/uikit/Box';
import Frame from '@client/uikit/Frame';
import { ChannelProvider, useChannelStore } from './ChannelProvider';
import { FloatingPostButton, PostButton } from './PostButton';
import PostList from './PostList';
import webViewStore from '@client/store/webViewStore';

const ChannelPageContent = observer(() => {
    const { channelType } = useParams();
    const channelStore = useChannelStore();

    return (
        <Frame>
            <Frame.Title title={channelStore.channel?.name} isLoading={channelStore.isLoading} />
            <Frame.Description>{channelStore.channel?.description}</Frame.Description>
            {!webViewStore.isWebView && (
                <div className="shown-when-desktop absolute right-0 hidden">
                    <PostButton className="size-12" />
                </div>
            )}
            <Box isLoading={channelStore.isLoading}>
                {channelStore.channel && <PostList channelType={channelType as ChannelType} />}
            </Box>
            <FloatingPostButton />
        </Frame>
    );
});

const ChannelPage = observer(() => {
    const { channelType } = useParams();

    return (
        <ChannelProvider channelType={channelType as ChannelType}>
            <ChannelPageContent />
        </ChannelProvider>
    );
});

export default ChannelPage;
